import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiBook, FiExternalLink, FiAlertTriangle } from 'react-icons/fi';

const policies = [
  { id: 1, title: 'Information Security Policy', version: 'v3.2', status: 'Active', reviewDue: '2024-12-01', gaps: 0 },
  { id: 2, title: 'Data Classification & Handling', version: 'v1.0', status: 'Draft', reviewDue: '2024-11-15', gaps: 2 },
  { id: 3, title: 'Incident Response Plan', version: 'v2.1', status: 'Active', reviewDue: '2025-01-20', gaps: 0 },
  { id: 4, title: 'Vendor Risk Management', version: 'v1.5', status: 'Review Needed', reviewDue: '2024-10-01', gaps: 1 },
];

const PolicyLibrary = () => {
  return (
    <div className="space-y-6">
       <div>
          <h1 className="text-3xl font-bold text-slate-100">Policy Library</h1>
          <p className="text-slate-400 mt-1">Central repository for all organizational policies and procedures.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {policies.map((policy, i) => (
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.1 }}
              key={policy.id}
              className="bg-slate-800/40 border border-slate-700/50 rounded-xl p-6 backdrop-blur-sm hover:border-amber-500/30 transition-all group"
            >
              <div className="flex justify-between items-start mb-4">
                <div className="p-3 bg-slate-900/50 rounded-lg text-amber-500">
                  <SafeIcon icon={FiBook} className="text-xl" />
                </div>
                <span className={`text-xs px-2 py-1 rounded-full border ${
                  policy.status === 'Active' ? 'bg-emerald-500/10 border-emerald-500/30 text-emerald-400' :
                  policy.status === 'Draft' ? 'bg-slate-500/10 border-slate-500/30 text-slate-400' :
                  'bg-amber-500/10 border-amber-500/30 text-amber-400'
                }`}>
                  {policy.status}
                </span>
              </div>
              
              <h3 className="text-lg font-semibold text-slate-200 mb-1 group-hover:text-amber-400 transition-colors flex items-center gap-2">
                {policy.title}
                <SafeIcon icon={FiExternalLink} className="text-sm opacity-0 group-hover:opacity-100 transition-opacity" />
              </h3>
              <p className="text-sm text-slate-500 mb-4">Version {policy.version}</p>
              
              <div className="pt-4 border-t border-slate-700/50 flex justify-between items-center text-sm">
                <span className="text-slate-400">Next Review: {policy.reviewDue}</span>
                {policy.gaps > 0 && (
                   <span className="flex items-center gap-1 text-red-400 bg-red-400/10 px-2 py-0.5 rounded">
                     <SafeIcon icon={FiAlertTriangle} /> {policy.gaps} Gaps
                   </span>
                )}
              </div>
            </motion.div>
          ))}
        </div>
    </div>
  );
};

export default PolicyLibrary;